<template>
	<div class="page">
		<!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="100px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
			<el-form-item label="合作商订单编号">
                <el-input v-model="queryForm.nonce" placeholder="请输入订单编号" style="width: 200px" size="small"></el-input>
            </el-form-item>
			<el-form-item label="审核状态">
				<el-select v-model="queryForm.auditStatus" placeholder="请选择审核状态" size="small" clearable style="width: 200px">
					<el-option label="待审核" :value="0"></el-option>
					<el-option label="通过" :value="1"></el-option>
					<el-option label="驳回" :value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="发放状态">
				<el-select v-model="queryForm.fulfillStatus" placeholder="请选择发放状态" size="small" clearable style="width: 200px">
					<el-option label="未发放" :value="0"></el-option>
					<el-option label="待补地址" :value="1"></el-option>
					<el-option label="已发放" :value="2"></el-option>
					<el-option label="失败" :value="3"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="物流状态">
				<el-select v-model="queryForm.auditStatus" placeholder="请选择物流状态" size="small" clearable style="width: 200px">
					<el-option label="待处理" :value="0"></el-option>
					<el-option label="待发货" :value="1"></el-option>
					<el-option label="已发货" :value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="手机号">
                <el-input v-model="queryForm.userMobile" placeholder="请输入手机号" style="width: 200px" size="small"></el-input>
            </el-form-item>
			<el-form-item label="创建时间">
				<el-date-picker
                    v-model="queryForm.createTime"
                    style="width: 200px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                ></el-date-picker>
			</el-form-item>
			<el-form-item label="金额">
				<el-input v-model="queryForm.minAmount" type="number" placeholder="请输入金额下限" style="width: 200px" size="small"></el-input>
				<span style="margin-left: 10px; margin-right: 10px;">-</span>
				<el-input v-model="queryForm.maxAmount" type="number" placeholder="请输入金额上限" style="width: 200px" size="small"></el-input>
			</el-form-item>

			<el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="toSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="toRefresh">重置</el-button>
            </el-form-item>
		</el-form>
		<div class="page-content">
			<div class="page-tool-bar">
				<div class="el-btn-group" style="display: flex">
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-s-claim"
                        :disabled="multipleSelection.length <= 0"
						@click="batchReview"
                    >批量审核</el-button
                    >
                </div>
				<div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
					<span class="icon-box" title="导入数据" @click="isImport">
                        <Icon color="#606266">
                            <ArrowExportUp24Regular />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopProductOrderList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
			</div>
			<el-table
				row-key="id"
				size="small" 
				height="100%" 
				:data="tableData" 
				border 
				style="width: 100%"
				ref="multipleTable"
				@selection-change="handleSelectionChange"
			>
				<el-table-column align="center" type="selection" width="60" :selectable="(row) => row.auditStatus == 0"></el-table-column>
				<el-table-column fixed prop="id" label="ID" width="200"></el-table-column>
				<el-table-column prop="nonce" label="合作商进线ID" width="200"></el-table-column>
				<!-- <el-table-column label="合作方" width="200">
					<template slot-scope="scope">
						<p>合作方名称：{{ scope.row.partnerName }}</p>
						<p>用户标识：{{ scope.row.partnerUserId }}</p>
						<p>用户昵称：{{ scope.row.userName }}</p>
					</template>
				</el-table-column>
				<el-table-column label="推荐人" width="300">
					<template slot-scope="scope">
						<p>手机号：{{ scope.row.referrerMobile }}</p>
						<p>本系统推荐人ID：{{ scope.row.referrerId }}</p>
						<p>推荐人是否在本系统：{{ scope.row.referrerExists ? "是" : "否" }}</p>
					</template>
				</el-table-column> -->
				<el-table-column label="业务用户" width="300">
					<template slot-scope="scope">
						<p>手机号：{{ scope.row.userMobile }}</p>
						<p>收货人：{{ scope.row.orderContact }}</p>
						<p>收货地址：{{ scope.row.orderAddress }}</p>
						<!-- <p>本系统用户ID：{{ scope.row.userId }}</p> -->
						<p>进线时是否新注册用户：{{ scope.row.isNewUser ? "是" : "否" }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="进线金额" width="100"></el-table-column>
				<!-- <el-table-column label="审核" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.auditStatus == 0">待审核</el-tag>
						<el-tag type="success" v-if="scope.row.auditStatus == 1">已通过</el-tag>
						<el-tag type="warning" v-if="scope.row.auditStatus == 2">已驳回</el-tag>
					</template>
				</el-table-column> -->
				<el-table-column label="发放" width="130">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.fulfillStatus == 0">未发放</el-tag>
						<el-tag v-if="scope.row.fulfillStatus == 1">待补地址</el-tag>
						<el-tag type="success" v-if="scope.row.fulfillStatus == 2">已发放成功</el-tag>
						<el-tag type="warning" v-if="scope.row.fulfillStatus == 3">发放失败</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="auditUserId" label="审核人ID" width="200"></el-table-column>
				<el-table-column prop="auditRemark" label="审核备注" width="120"></el-table-column>
				<el-table-column prop="failReason" label="最近一次发放失败原因" width="100"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
				<el-table-column prop="updateTime" label="更新时间" width="200"></el-table-column>
				<el-table-column label="审核时间" width="200">
					<template slot-scope="scope">{{ new Date(scope.row.auditTime).toLocaleString() }}</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="100">
					<template slot-scope="scope">
						<el-button v-if="scope.row.auditStatus == 0" @click="checkProduct(scope.row)" type="primary" size="small">
							审核
						</el-button>
						<el-button v-if="scope.row.auditStatus == 1" type="primary" size="small" disabled>已通过</el-button>
						<el-button v-if="scope.row.auditStatus == 2" type="danger" size="small" disabled>已驳回</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-box">
				<el-pagination
					@size-change="sizeChange"
					@current-change="currentChange"
					:current-page.sync="currentPage"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalNum"
					background
					:pager-count="7"
				></el-pagination>
			</div>
		</div>

		<el-dialog
			title="提示"
			:visible.sync="checkProductDialogVisible"
			width="35%"
			:before-close="closeCheckProductDialog"
		>
			<el-form :rules="rules" :model="checkProductForm" ref="checkProductForm" label-position="right" label-width="90px">
				<el-form-item label="商品审核" prop="auditStatus">
					<el-radio-group v-model="checkProductForm.auditStatus">
						<el-radio label="1">通过</el-radio>
						<el-radio label="2">拒绝</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="checkProductForm.auditStatus == 1 && !checkProductForm.ids" label="审核类型" prop="mode">
					<el-radio-group v-model="checkProductForm.mode">
						<el-radio label="1">金额</el-radio>
						<el-radio label="2">商品</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="(checkProductForm.auditStatus == 1 && checkProductForm.mode == 1) || checkProductForm.ids" label="金额" prop="grantAmount">
					<el-input
						placeholder="请输入金额"
						style="width: 50%"
						v-model="checkProductForm.grantAmount"
						type="number"
					></el-input>
					<el-button style="margin-left: 10px;" @click="() => checkProductForm.grantAmount = 70">70</el-button>
					<el-button  @click="() => checkProductForm.grantAmount = 170">170</el-button>
				</el-form-item>
				<el-form-item v-if="checkProductForm.auditStatus == 1 && checkProductForm.mode == 2" label="商品" prop="productId">
					<el-input
						size="small"
						placeholder="请选择商品"
						style="width: 50%"
						:value="checkProductForm.productName"
						@focus="handleFocus"
					></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="auditRemark">
					<el-input
						placeholder="请输入备注"
						type="textarea"
						size="small"
						:rows="3"
						v-model="checkProductForm.auditRemark"
						style="width: 80%"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeCheckProductDialog">取 消</el-button>
				<el-button type="primary" @click="editCheckProduct()">确 定</el-button>
			</span>
		</el-dialog>

		<productListDialog
			v-if="productListVisible"
			:visible="productListVisible"
			@close="handleProductList"
		></productListDialog>

		<!-- 导入Excel弹窗 -->
		<el-dialog title="导入Excel" :visible.sync="uploadExcelVisible" top="10vh" width="80%" :before-close="handleClose">
			<div class="upload-dialog-content">
				<el-upload
					class="upload-demo"
					action="#"
					:limit="1"
					:show-file-list="false"
					:before-upload="beforeAvatarUpload"
					:http-request="upload"
				>
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
				</el-upload>
				<div style="margin-top: 10px;">
					<el-button
						type="primary"
						plain
						size="small"
						icon="el-icon-s-claim"
						:disabled="multipleSelection.length <= 0"
						@click="batchReview"
					>批量审核</el-button
					>
				</div>
				<div>
					<el-table :data="uploadTableData" style="width: 100%;" border row-key="id" @selection-change="handleSelectionChange">
						<el-table-column align="center" type="selection" width="60" :selectable="(row) => row.status == 'MATCHED'"></el-table-column>
						<el-table-column prop="excelOrderNo" label="订单号"></el-table-column>
						<el-table-column prop="excelGrantAmount" label="导入金额" width="100"></el-table-column>
						<el-table-column prop="excelUserName" label="用户名"></el-table-column>
						<el-table-column prop="excelMobile" label="手机号"></el-table-column>
						<el-table-column prop="statusText" label="匹配状态"></el-table-column>
						<el-table-column prop="recordAmount" label="本地当前金额"></el-table-column>
						<el-table-column prop="recordUserName" label="本地用户名"></el-table-column>
						<el-table-column prop="recordMobile" label="本地手机号"></el-table-column>
					</el-table>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
            </span>
		</el-dialog>
	</div>
</template>

<script>
	import { get, post, postJson, put, deleteFun } from "@/utils/request.js";
	import productListDialog from "./productListDialog.vue";
	import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
	import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
	import { importDate } from '@/utils/request.js';

	export default {
		data() {
			return {
				queryForm: {},
				tableData: [],
				pageSize: 10,
				currentPage: 1,
				totalNum: 0,
				checkProductDialogVisible: false, //审核商品弹窗
				checkProductForm: {
					id: "",
					productId: "",
					productName: "",
					auditRemark: "",
					auditStatus: "", // 审核状态
					grantAmount: "", // 金额
					mode: "", // 审核类型
				},
				rules: {
					auditStatus: [{ required: true, message: "审核状态不能为空", trigger: "blur" }],
					mode: [{ required: true, message: "审核类型不能为空", trigger: "blur" }],
					productId: [{ required: true, message: "商品不能为空", trigger: "blur" }],
					grantAmount: [{ required: true, message: "金额不能为空", trigger: "blur" }],
				},
				productListVisible: false,
				isSearch: false,
				multipleSelection: [],
				uploadExcelVisible: false,
				uploadTableData: [],
				uploadFormData: new FormData()
			};
		},
		watch: {
			"checkProductForm.auditStatus"() {
				let checkProductForm = this.$copy(this.checkProductForm);
				this.checkProductForm = {
					...checkProductForm,
					productId: "",
					productName: "",
					auditRemark: "",
				};
			},
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				if (this.queryForm.createTime) {
					this.queryForm.startCreateTime = this.queryForm.createTime[0];
					this.queryForm.endCreateTime = this.queryForm.createTime[1];
					delete this.queryForm.createTime;
				}
				get("/shop/partnerinbound/findList", {
					...this.queryForm,
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}).then((res) => {
					if (res.success && res.code == 200) {
						this.tableData = res.page.list;
						this.totalNum = res.page.total;
					}
				});
			},
			currentChange(page) {
				this.currentPage = page;
				this.getList();
			},
			sizeChange(size) {
				this.pageSize = size;
				this.getList();
			},
			resetList() {
				this.tableData = [];
				this.currentPage = 1;
				this.getList();
			},
			checkProduct(row) {
				this.checkProductDialogVisible = true;
				this.checkProductForm.id = row.id;
			},
			closeCheckProductDialog() {
				this.checkProductDialogVisible = false;
				this.checkProductForm = {
					id: "",
					productId: "",
					productName: "",
					auditStatus: "", // 审核状态
					auditRemark: "",
					mode: "", // 审核类型
					grantAmount: "", // 金额
				};
			},
			editCheckProduct() {
				let form = this.$copy(this.checkProductForm);
				delete form.productName;
				let params = "";
				if (!!form.ids) {
					postJson("/shop/partnerinbound/batchAuditAmountToPintuan", form).then((res) => {
						if (res.success) {
							this.$message({
								message: res.msg,
								type: "success",
								duration: 2000,
							});
							if (this.uploadExcelVisible) {
								importDate('/shop/partnerinbound/importAuditAmountPreview', this.uploadFormData).then((res) => {
									if (res.success) {
										this.uploadTableData = res.previewItems;
									} else {
										this.$message({
											message: res.msg,
											type: "error",
											duration: 2000,
										});
									}
								});
							}
							this.closeCheckProductDialog();
							this.resetList();
						} else {
							this.$message({
								message: res.msg,
								type: "error",
								duration: 2000,
							});
						}
					});
				} else {
					if (form.mode == 1) {
						params = `?id=${form.id}&grantAmount=${form.grantAmount}&auditStatus=${form.auditStatus}&auditRemark=${form.auditRemark}`;
						postJson("/shop/partnerinbound/auditAmountToPintuan" + params, {}).then((res) => {
							if (res.success) {
								this.$message({
									message: res.msg,
									type: "success",
									duration: 2000,
								});
								this.closeCheckProductDialog();
								this.resetList();
							} else {
								this.$message({
									message: res.msg,
									type: "error",
									duration: 2000,
								});
							}
						});
					} else {
						params = `?id=${form.id}&productId=${form.productId}&auditStatus=${form.auditStatus}&auditRemark=${form.auditRemark}`;
						postJson("/shop/partnerinbound/grantWithProduct" + params, {}).then((res) => {
							if (res.success) {
								this.$message({
									message: res.msg,
									type: "success",
									duration: 2000,
								});
								this.closeCheckProductDialog();
								this.resetList();
							} else {
								this.$message({
									message: res.msg,
									type: "error",
									duration: 2000,
								});
							}
						});
					}
				}
			},
			handleFocus() {
				console.log("handleFocus");
				this.productListVisible = true;
			},
			handleProductList(val) {
				this.productListVisible = false;
				console.log("handleProductList", val);
				if (val) {
					this.checkProductForm.productId = val.id;
					this.checkProductForm.productName = val.productName;
					this.$refs["checkProductForm"].validate();
				}
			},
			search() {
				this.isSearch = !this.isSearch;
			},
			toSearch() {
				this.pageNum = 1;
				this.getList();
			},
			refreshShopProductOrderList() {
				this.getList();
			},
			handleSelectionChange(value) {
				this.multipleSelection = value.filter(item => item.auditStatus == 0 || item.status == 'MATCHED').map(item => item.id || item.recordId);
			},
			toRefresh() {
				this.queryForm = {};
				this.pageNum = 1;
				this.getList();
			},
			batchReview() {
				this.checkProductDialogVisible = true;
				this.checkProductForm.ids = this.multipleSelection;
			},
			isImport() {
				this.uploadExcelVisible = true;
				this.multipleSelection = [];
				this.$res.multipleTable.clearSelection();
			},
			handleClose() {
				this.uploadExcelVisible = false;
				this.uploadTableData = [];
				this.uploadFormData = new FormData();
				this.multipleSelection = [];
			},
			beforeAvatarUpload(file) {
				if (
					['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].indexOf(file.type) ==
					-1
				) {
					this.$message.error('请上传正确类型的文件格式');
					return false;
				}
			},
			upload(params) {
				const file = params.file;
				this.uploadFormData.append('file', file);
				console.log("formData", this.uploadFormData.get('file'));
				importDate('/shop/partnerinbound/importAuditAmountPreview', this.uploadFormData).then((res) => {
					if (res.success) {
						this.uploadTableData = res.previewItems;
					} else {
						this.$message({
							message: res.msg,
							type: "error",
							duration: 2000,
						});
					}
				});
			},
		},
		components: {
			productListDialog,
			GridDots,
			Refresh,
			Printer,
			ArrowUp,
			ArrowDown,
			Search,
			ArrowExportUp24Regular,
		},
	};
</script>

<style lang="scss" scoped>
	.page {
		height: 100%;
		padding: 10px;
		background-color: #fff;

		.page-content {
			height: 93%;
			padding: 0;
			border: 0;
		}
	}

	::v-deep .el-dialog__body {
		padding: 20px !important;

		.upload-dialog-content {
			max-height: 60vh;
			overflow: auto;
		}
	}
	::v-deep .el-upload--text {
		width: auto;
		height: auto;
		border: 0;
	}
</style>
